import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.camera');
import { OnInit, Input } from "@angular/core";
import { ElementRef, ViewChild } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-kiosk-camera',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.camera/view.scss */
/* src/app/portal.kiosk.camera/view.scss: no such file or directory */`],
})
export class PortalKioskCameraComponent implements OnInit {
    @ViewChild('video') video: ElementRef;
    @ViewChild('canvas') canvas: ElementRef;
    @ViewChild('capturedImage') capturedImage: ElementRef;

    @Input() event: any;
    @Input() opts: any;

    public imageCapture: any;
    public status: any = 'ready';
    public countdown: any = 5;

    public place = '';
    public character = '';

    private readonly imageGenerationStatusKey = 'imageGenerationStatus';
    private readonly imageGenerationStatusEvent = 'imageGenerationStatusChanged';

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.route.queryParams.subscribe(params => {
            this.place = params['place'];
            this.character = params['character'];
        });
        await this.service.render();

        const video = this.video.nativeElement;
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(async (stream) => {
                video.srcObject = stream;
                const track = stream.getVideoTracks()[0];
                this.imageCapture = new ImageCapture(track);
                await this.imageCapture.takePhoto();
            }).catch(err => { });
        await this.take();
    }

    public async take() {
        this.status = 'capture';
        this.countdown = 5;
        await this.service.render();

        for (let i = 5; i > 0; i--) {
            await this.service.render(1000);
            this.countdown = this.countdown - 1;
        }

        let blob = await this.imageCapture.takePhoto();

        this.status = 'captured';
        await this.service.render();


        blob = await this.cropImageToRatio(blob, 1080, 1020);
        this.blob = blob;

        const url = URL.createObjectURL(blob);
        this.capturedImage.nativeElement.src = url;

        this.countdown = 5;
        await this.service.render();
    }

    // public async create() {
    //     await this.event.set("image", this.blob);
    //     await this.event.view("create");
    // }

    public async restart() {
        this.status = 'ready';
        await this.service.render();

        const video = this.video.nativeElement;
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(async (stream) => {
                video.srcObject = stream;
                const track = stream.getVideoTracks()[0];
                this.imageCapture = new ImageCapture(track);
                await this.imageCapture.takePhoto();
            }).catch(err => { });
    }

    public cropImageToRatio(blob: Blob, targetWidth: number, targetHeight: number): Promise<Blob> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const targetRatio = targetWidth / targetHeight;

            img.onload = () => {
                const originalWidth = img.width;
                const originalHeight = img.height;
                const originalRatio = originalWidth / originalHeight;

                let cropWidth, cropHeight, offsetX, offsetY;

                if (originalRatio > targetRatio) {
                    cropHeight = originalHeight;
                    cropWidth = cropHeight * targetRatio;
                    offsetX = (originalWidth - cropWidth) / 2;
                    offsetY = 0;
                } else {
                    // 원본이 더 높은 경우
                    cropWidth = originalWidth;
                    cropHeight = cropWidth / targetRatio;
                    offsetX = 0;
                    offsetY = (originalHeight - cropHeight) / 2;
                }

                const canvas = document.createElement('canvas');
                canvas.width = cropWidth;
                canvas.height = cropHeight;
                const ctx = canvas.getContext('2d');

                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);

                ctx.drawImage(
                    img,
                    offsetX, offsetY, cropWidth, cropHeight,
                    0, 0, cropWidth, cropHeight
                );

                canvas.toBlob((croppedBlob) => {
                    if (croppedBlob) {
                        resolve(croppedBlob);
                    } else {
                        reject(new Error('Crop failed'));
                    }
                }, 'image/jpeg');
            };

            img.onerror = (err) => {
                reject(err);
            };

            img.src = URL.createObjectURL(blob);
        });
    }

    public async create() {

        const formData = new FormData();
        formData.append("place", this.place);
        formData.append("character", this.character);
        formData.append("image", this.blob, "capture.jpg");

        this.setImageGenerationStatus('generating');

        fetch(wiz.url('create'), { method: "POST", body: formData })
            .then(response => {
                this.setImageGenerationStatus(response.ok ? 'completed' : 'failed');
                if (!response.ok) {
                    console.error('이미지 생성 요청 실패', response.status);
                }
            })
            .catch(error => {
                this.setImageGenerationStatus('failed');
                console.error('이미지 생성 요청 오류', error);
            });

        await this.router.navigate(['/main/quiz']);
    }

    private setImageGenerationStatus(status: 'generating' | 'completed' | 'failed') {
        sessionStorage.setItem(this.imageGenerationStatusKey, status);
        window.dispatchEvent(new CustomEvent(this.imageGenerationStatusEvent, { detail: status }));
    }


}

export default PortalKioskCameraComponent;